// Read more — afficher le bouton uniquement si le texte dépasse 3 lignes
document.querySelectorAll('.mm-collection-hero-v1__desc--mobile').forEach(function (wrapper) {
    var textEl = wrapper.querySelector('.mm-collection-hero-v1__desc-text');
    var readMore = wrapper.querySelector('.mm-collection-hero-v1__read-more');
    if (!textEl || !readMore) return;
    // scrollHeight > clientHeight indique un débordement (texte clampé)
    if (textEl.scrollHeight <= textEl.clientHeight) {
        readMore.style.display = 'none';
    }
});

// Splide
document.querySelectorAll('.mm-collection-hero-v1__splide').forEach(function (el) {
    if (!el.classList.contains('mm-is-initialized')) {
        try {
            el.classList.add('mm-is-initialized');
            const splide = new Splide(el);
            splide.on('overflow', function (isOverflow) {
                const arrowsEl = el.querySelector('.splide__arrows');
                if (arrowsEl) arrowsEl.hidden = !isOverflow;
            });
            splide.mount();
        } catch (e) {
            console.warn('Splide init error:', e);
        }
    }
});